export default "__VITE_ASSET__CWHwo_$W__"